import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import { useSelector } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import AddUser_popup from "../users/AddUser_popup";

export default function AlertDialog(props) {
  const {updstate} = props;
  const [open, setOpen] = React.useState(true);
  const [closee, setclosee] = useState(false);
  const [updated, setUpdated] = useState(false);
  const handleClose = () => {
    setOpen(false);  
    props.close(false);
  };

  const closepop = ()=>{
    setUpdated(prev => !prev)
    handleClose()
  }
 
  const {
    user: { user },
  } = useSelector((state) => state);
const revTable = (val)=>{
  props.newAddAdmin(val);



}
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AddUser_popup updstate = {closepop} addNewTable={revTable} title={props.title}/>
          
      </Dialog>
    </div>
  );
}
